<div class="d-flex flex-column h-100 pb-2">
    <div class="alert alert-warning">Printing is not supported for this page, please download to Excel.</div>
    <div class="d-flex justify-content-between mb-2">
        <h2>Cost Center - Improvements - Iacts 6710 & 6715</h2>
        <div class="d-flex flex-column mt-1">
            <button type="button" class="btn btn-secondary btn-block" (click)="exportToExcel()">
                Excel <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
            </button>
        </div>
    </div>
    <p class="excludesMessage" style="margin-bottom: 1rem;">Excludes future dated chartfield values</p>
    <ag-grid-angular class="ag-theme-balham h-100 pb-2"
                     [gridOptions]="gridOptions"
                     (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>
